import { useState } from 'react';

import { BorrowStatusType } from '@/shared/api/borrow';

export const useBorrowStatus = () => {
    const [selectedBorrowStatusList, setSelectedBorrowStatusList] = useState<BorrowStatusType>(
        BorrowStatusType.OPENED,
    );

    const handleSelectedBorrowStatusListChange = (value: number | string) => {
        setSelectedBorrowStatusList(value as BorrowStatusType);
    };

    return { selectedBorrowStatusList, handleSelectedBorrowStatusListChange };
};
